import { FormControl } from '@angular/forms';

export function invalidValues(validableValues: string[] ) {
    return (control: FormControl): { [key: string]: any } => {

        let isValid = true;
        if (validableValues) {
            isValid = !validableValues.some(e => e === control.value);
        }

        return !isValid ? { 'invalidValues': true }
            : null;
    };
}